<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-07-14 15:00:40
 * @FilePath: \watherfocast2\src\views\HomeView.vue
 * @Description: 首页 - 光伏预测平台
-->
<template>
  <div class="homeViewBody">
    <div class="homeViewHeader">
      分布式光伏电站精细化光伏功率预报平台
      <div class="timeBox">
        {{ currentTime }}
      </div>
      <div class="locBox"></div>
    </div>
    <div class="myheaderBtnBox">
       <div class="myheaderBtnitem"></div>
       <div class="myheaderBtnitem"></div>
       <div class="myheaderBtnitem"></div>
      <!-- <div class="myheaderBtnitem">首页</div>
      <div class="myheaderBtnitem" @click="goToStatistics">统计查询</div>
      <div class="myheaderBtnitem" @click="goToPrediction">预测分析</div> -->
      <div class="myheaderBtnitem user-menu" @click="handleLogout">
        <i class="el-icon-user-solid"></i>
        退出登录
      </div>
    </div>
    <div class="homeMainBox">
      <div class="mainLayout">
        <!-- 左侧区域 -->
        <div class="leftColumn">
          <!-- 数据概览 -->
          <div class="card overview-card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">数据概览</div>
                <div class="overview-grid">
                  <div class="overview-item">
                    <div class="overview-value">{{ overviewData.stationCount }}</div>
                    <div class="overview-label">电站数量</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ overviewData.avgRadiation }}<span class="unit"> W/m²</span></div>
                    <div class="overview-label">平均辐射</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ overviewData.maxRadiation }}<span class="unit"> W/m²</span></div>
                    <div class="overview-label">最大辐射</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ overviewData.power }}<span class="unit"> MW</span></div>
                    <div class="overview-label">预测功率</div>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 功率趋势图 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">辐射趋势</div>
                <div class="chart-content" ref="trendChart"></div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 实况 vs 预测辐射 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">实况 vs 预测辐射</div>
                <div class="chart-content" ref="radiationChart"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <!-- 中间区域 -->
        <div class="centerColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container" style="padding:0;">
                <div class="map-toolbar">
                  <span class="toolbar-label">数据类型：</span>
                  <button 
                    v-for="type in dataTypes" 
                    :key="type.value"
                    :class="['toolbar-btn', { active: currentDataType === type.value }]"
                    @click="switchDataType(type.value)"
                  >
                    {{ type.label }}
                  </button>
                  <div class="opacity-control">
                    <span class="opacity-label">透明度：</span>
                    <input 
                      type="range" 
                      v-model="opacityValue" 
                      min="0.1" 
                      max="1" 
                      step="0.1"
                      @input="updateOpacity"
                      class="opacity-slider"
                    />
                    <span class="opacity-value">{{ (opacityValue * 100).toFixed(0) }}%</span>
                  </div>
                </div>
                <div id="pvMap" class="map-chart"></div>
                <div class="legend">
                  <span class="legend-title">图例</span>
                  <div class="legend-items">
                    <div v-for="(color, index) in legendColors" :key="index" class="legend-item">
                      <span class="legend-color" :style="{ backgroundColor: color.color }"></span>
                      <span class="legend-text">{{ color.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 未来十天功率预测 -->
          <div class="card" style="flex:0 0 220px;">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">未来十天功率预测</div>
                <div class="chart-content" ref="forecastChart"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <!-- 右侧区域 -->
        <div class="rightColumn">
          <!-- 发电概况 -->
          <div class="card overview-card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">发电概况</div>
                <div class="overview-grid">
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.currPower }}<span class="unit"> MW</span></div>
                    <div class="overview-label">当前功率</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.dailyGen }}<span class="unit"> MWh</span></div>
                    <div class="overview-label">今日发电</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.efficiency }}<span class="unit">%</span></div>
                    <div class="overview-label">转换效率</div>
                  </div>
                  <div class="overview-item">
                    <div class="overview-value">{{ powerData.co2 }}<span class="unit"> t</span></div>
                    <div class="overview-label">减排CO₂</div>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 发电功率图表 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">
                  实况 vs 预报功率
                  <div class="chart-controls">
                    <select v-model="powerStationId" @change="fetchPowerCompare" class="mini-select">
                      <option value="CN0001">CN0001</option>
                      <option value="CN0002">CN0002</option>
                      <option value="CN0003">CN0003</option>
                    </select>
                    <input type="date" v-model="powerDate" @change="fetchPowerCompare" class="mini-date" />
                  </div>
                </div>
                <div class="chart-content" ref="powerChart"></div>
              </div>
            </dv-border-box-8>
          </div>
          <!-- 电站排名表 -->
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">功率排名</div>
                <div class="chart-content table-wrap">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>电站</th>
                        <th>功率(MW)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in powerRankList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.power }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </dv-border-box-8>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MapCreate, L } from '../map/mapImport.js'
import * as echarts from 'echarts'
import axios from 'axios'
import { parseGrayscalePNG } from '../utils/imageParser.js'
import dataPng from '../assets/data.png'

export default {
  name: 'HomeView',
  data() {
    return {
      currentTime: '',
      mapData: null,
      gridDataLayer: null,
      gridData: [],
      currentDataType: 'dswrf',
      opacityValue: 0.6,
      trendChartInstance: null,
      powerChartInstance: null,
      forecastChartInstance: null,
      radiationChartInstance: null,
      powerCompareData: [],
      powerStationId: 'CN0001',
      powerDate: '2019-01-01',
      imageGridData: null,
      imageGridMeta: null,
      powerData: {
        currPower: '42.8',
        dailyGen: '286.5',
        efficiency: '18.2',
        co2: '142.3'
      },
      powerRankList: [
        { name: '格尔木站', power: '48.5' },
        { name: '德令哈站', power: '42.3' },
        { name: '共和站', power: '38.7' },
        { name: '西宁站', power: '35.2' },
        { name: '兰州站', power: '31.6' }
      ],
      overviewData: {
        stationCount: 128,
        avgRadiation: '456.8',
        maxRadiation: '892.3',
        power: '48.6'
      },
      stationList: [
        { name: '格尔木站', radiation: '532.1', temp: '24.5' },
        { name: '德令哈站', radiation: '487.6', temp: '22.3' },
        { name: '共和站', radiation: '618.9', temp: '26.1' },
        { name: '西宁站', radiation: '412.3', temp: '21.8' },
        { name: '兰州站', radiation: '398.7', temp: '23.2' }
      ],
      dataTypes: [
        { label: '向下短波辐射通量', value: 'dswrf' },
        { label: '总云量', value: 'tcdc' },
        { label: '向上短波辐射通量', value: 'uswrf' }
      ],
      legendColors: [
        { color: '#313695', label: '0-10' },
        { color: '#4575b4', label: '10-20' },
        { color: '#74add1', label: '20-30' },
        { color: '#abd9e9', label: '30-40' },
        { color: '#e0f3f8', label: '40-50' },
        { color: '#ffffbf', label: '50-60' },
        { color: '#fee090', label: '60-70' },
        { color: '#fdae61', label: '70-80' },
        { color: '#f46d43', label: '80-90' },
        { color: '#d73027', label: '90+' }
      ]
    }
  },
  mounted() {
    this.updateTime()
    this.initMap()
    this.fetchImageGridData()
    this.parseImageData()
    this.$nextTick(() => {
      this.initTrendChart()
      this.initPowerChart()
      this.initForecastChart()
      this.initRadiationChart()
    })
    setInterval(() => {
      this.updateTime()
    }, 1000)
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.mapData && this.mapData.map) {
      this.mapData.map.remove()
      this.mapData = null
    }
    this.clearGridData()
    if (this.trendChartInstance) {
      this.trendChartInstance.dispose()
      this.trendChartInstance = null
    }
    if (this.powerChartInstance) {
      this.powerChartInstance.dispose()
      this.powerChartInstance = null
    }
    if (this.forecastChartInstance) {
      this.forecastChartInstance.dispose()
      this.forecastChartInstance = null
    }
    if (this.radiationChartInstance) {
      this.radiationChartInstance.dispose()
      this.radiationChartInstance = null
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initMap() {
      this.mapData = new MapCreate()
      this.mapData.init('pvMap')
    },
    initTrendChart() {
      const dom = this.$refs.trendChart
      if (!dom) return
      this.trendChartInstance = echarts.init(dom)
      const hours = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']
      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['总辐射', '功率预测']
        },
        grid: { left: 45, right: 45, top: 20, bottom: 35 },
        xAxis: {
          type: 'category',
          data: hours,
          axisLabel: { color: '#999', fontSize: 10, rotate: 30 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: [
          {
            type: 'value',
            name: 'W/m²',
            nameTextStyle: { color: '#00d8ff', fontSize: 10 },
            splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
            axisLabel: { color: '#00d8ff', fontSize: 10 },
            axisLine: { lineStyle: { color: '#00d8ff' } }
          },
          {
            type: 'value',
            name: 'MW',
            nameTextStyle: { color: '#f9ca24', fontSize: 10 },
            splitLine: { show: false },
            axisLabel: { color: '#f9ca24', fontSize: 10 },
            axisLine: { lineStyle: { color: '#f9ca24' } }
          }
        ],
        series: [
          {
            name: '总辐射',
            data: [120, 245, 380, 512, 620, 658, 602, 498, 356, 198, 85],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: { color: '#00d8ff', width: 2 },
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.25)' },
                { offset: 1, color: 'rgba(0,216,255,0.02)' }
              ])
            }
          },
          {
            name: '功率预测',
            yAxisIndex: 1,
            data: [7.8, 18.2, 28.5, 38.1, 46.2, 48.8, 45.3, 38.6, 27.5, 15.4, 5.6],
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              borderRadius: [3, 3, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(249,202,36,0.9)' },
                { offset: 1, color: 'rgba(249,202,36,0.15)' }
              ])
            }
          }
        ]
      }
      this.trendChartInstance.setOption(option)
    },
    handleResize() {
      if (this.trendChartInstance) {
        this.trendChartInstance.resize()
      }
      if (this.powerChartInstance) {
        this.powerChartInstance.resize()
      }
      if (this.forecastChartInstance) {
        this.forecastChartInstance.resize()
      }
      if (this.radiationChartInstance) {
        this.radiationChartInstance.resize()
      }
    },
    async fetchPowerCompare() {
      try {
        const d = this.powerDate
        const response = await axios.get('https://moodsci.com/lsserver/wind/forcast/windPowerCompare', {
          params: {
            stationId: this.powerStationId,
            scTime: `${d} 08:00:00`,
            startTime: `${d} 11:00:00`,
            endTime: `${this.getNextDay(d)} 11:00:00`
          }
        })
        if (response.data && response.data.code === 200) {
          this.powerCompareData = response.data.data
          this.renderPowerChart()
        }
      } catch (error) {
        console.error('获取功率对比数据失败:', error)
      }
    },
    getNextDay(dateStr) {
      const d = new Date(dateStr)
      d.setDate(d.getDate() + 1)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    renderPowerChart() {
      const dom = this.$refs.powerChart
      if (!dom) return
      if (!this.powerChartInstance) {
        this.powerChartInstance = echarts.init(dom)
      }
      const times = this.powerCompareData.map(item => {
        const t = new Date(item.preTime)
        const h = String(t.getHours()).padStart(2, '0')
        const m = String(t.getMinutes()).padStart(2, '0')
        return `${h}:${m}`
      })
      const actualData = this.powerCompareData.map(item => item.actualPower)
      const predictData = this.powerCompareData.map(item => item.predictedPower)
      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['实况功率', '预报功率']
        },
        grid: { left: 40, right: 20, top: 20, bottom: 35 },
        dataZoom: [{ type: 'inside', start: 0, end: 100 }],
        xAxis: {
          type: 'category',
          data: times,
          axisLabel: { color: '#999', fontSize: 9, rotate: 30 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: 'MW',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '实况功率',
            data: actualData,
            type: 'bar',
            barWidth: 6,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.9)' },
                { offset: 1, color: 'rgba(0,216,255,0.15)' }
              ])
            }
          },
          {
            name: '预报功率',
            data: predictData,
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { color: '#f9ca24', width: 2 },
            itemStyle: { color: '#f9ca24' }
          }
        ]
      }
      this.powerChartInstance.setOption(option)
    },
    initPowerChart() {
      this.$nextTick(() => {
        this.fetchPowerCompare()
      })
    },
    initForecastChart() {
      const dom = this.$refs.forecastChart
      if (!dom) return
      this.forecastChartInstance = echarts.init(dom)
      const days = ['6/5', '6/6', '6/7', '6/8', '6/9', '6/10', '6/11', '6/12', '6/13', '6/14']
      const option = {
        tooltip: { trigger: 'axis' },
        grid: { left: 45, right: 20, top: 15, bottom: 25 },
        xAxis: {
          type: 'category',
          data: days,
          axisLabel: { color: '#999', fontSize: 10 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: 'MW',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '预测功率',
            data: [42.5, 43.2, 41.8, 44.6, 38.9, 45.1, 42.3, 40.7, 43.5, 41.2],
            type: 'bar',
            barWidth: 14,
            itemStyle: {
              borderRadius: [3, 3, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00d8ff' },
                { offset: 1, color: 'rgba(0,216,255,0.15)' }
              ])
            },
            label: {
              show: true,
              position: 'top',
              color: '#00d8ff',
              fontSize: 10,
              formatter: '{c}'
            }
          }
        ]
      }
      this.forecastChartInstance.setOption(option)
    },
    initRadiationChart() {
      const dom = this.$refs.radiationChart
      if (!dom) return
      this.radiationChartInstance = echarts.init(dom)
      const hours = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00']
      const option = {
        tooltip: { trigger: 'axis' },
        legend: {
          bottom: 0,
          textStyle: { color: '#999', fontSize: 10 },
          data: ['实况辐射', '预测辐射']
        },
        grid: { left: 45, right: 20, top: 20, bottom: 35 },
        xAxis: {
          type: 'category',
          data: hours,
          axisLabel: { color: '#999', fontSize: 10, rotate: 30 },
          axisLine: { lineStyle: { color: 'rgba(0,216,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: 'W/m²',
          splitLine: { lineStyle: { color: 'rgba(0,216,255,0.1)' } },
          axisLabel: { color: '#999', fontSize: 10 }
        },
        series: [
          {
            name: '实况辐射',
            data: [105, 230, 365, 495, 605, 640, 585, 480, 340, 185, 72],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 4,
            lineStyle: { color: '#00d8ff', width: 2 },
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0,216,255,0.25)' },
                { offset: 1, color: 'rgba(0,216,255,0.02)' }
              ])
            }
          },
          {
            name: '预测辐射',
            data: [120, 245, 380, 512, 620, 658, 602, 498, 356, 198, 85],
            type: 'line',
            smooth: true,
            symbol: 'diamond',
            symbolSize: 6,
            lineStyle: { color: '#f9ca24', width: 2, type: 'dashed' },
            itemStyle: { color: '#f9ca24' }
          }
        ]
      }
      this.radiationChartInstance.setOption(option)
    },
    async fetchImageGridData() {
      try {
        const today = new Date()
        today.setDate(today.getDate() - 1)
        const y = today.getFullYear()
        const m = String(today.getMonth() + 1).padStart(2, '0')
        const d = String(today.getDate()).padStart(2, '0')
        const dateStr = `${y}${m}${d}`

        const base = 'https://forecast-1303702531.cos.ap-chengdu.myqcloud.com/gfs/img'
        const urls = {
          dswrf: `${base}/DSWRF/${dateStr}/DSWRF_f001.png`,
          tcdc: `${base}/TCDC/${dateStr}/TCDC_f001.png`,
          uswrf: `${base}/USWRF/${dateStr}/USWRF_f001.png`
        }

        const results = {}
        let meta = null

        for (const [key, url] of Object.entries(urls)) {
          const parsed = await parseGrayscalePNG(url)
          results[key] = [].concat(...parsed.data)
          if (!meta) {
            meta = {
              left: parsed.lonMin,
              right: parsed.lonMax,
              top: parsed.latMax,
              bottom: parsed.latMin,
              rows: parsed.height,
              cols: parsed.width
            }
          }
        }

        this.imageGridData = results
        this.imageGridMeta = meta
        this.renderGridData()
      } catch (error) {
        console.error('获取图片格点数据失败:', error)
      }
    },
    switchDataType(type) {
      this.currentDataType = type
      this.renderGridData()
    },
    updateOpacity() {
      this.renderGridData()
    },
    renderGridData() {
      if (!this.mapData || !this.mapData.map || !this.imageGridData) return

      this.clearGridData()

      const dataArray = this.imageGridData[this.currentDataType]
      if (!dataArray) return

      const gridItem = this.imageGridMeta
      
      const opacity = parseFloat(this.opacityValue)
      const ledcolorList = [
        [0, [49, 54, 149, opacity]],
        [10, [69, 117, 180, opacity]],
        [20, [116, 173, 209, opacity]],
        [30, [171, 217, 233, opacity]],
        [40, [224, 243, 248, opacity]],
        [50, [255, 255, 191, opacity]],
        [60, [254, 224, 144, opacity]],
        [70, [253, 174, 97, opacity]],
        [80, [244, 109, 67, opacity]],
        [90, [215, 48, 39, opacity]],
        [100, [174, 25, 29, opacity]]
      ]
      
      this.gridDataLayer = L.tilePixelLayer({
        newData: dataArray,
        data: gridItem,
        gradient: ledcolorList,
        clickEvt: (e, gridValue) => {
          let popup = L.popup({
            autoPanPaddingBottomRight: L.point(600, 0)
          })
            .setLatLng([e.latlng.lat, e.latlng.lng])
            .setContent(`<div>格点值:${gridValue}</div>`)
            .openOn(this.mapData.map)
        }
      })
      
      this.gridDataLayer.addTo(this.mapData.map)
      
      this.mapData.map.fitBounds([
        [gridItem.bottom, gridItem.left],
        [gridItem.top, gridItem.right]
      ])
    },
    getColorByValue(value) {
      if (value < 10) return '#313695'
      if (value < 20) return '#4575b4'
      if (value < 30) return '#74add1'
      if (value < 40) return '#abd9e9'
      if (value < 50) return '#e0f3f8'
      if (value < 60) return '#ffffbf'
      if (value < 70) return '#fee090'
      if (value < 80) return '#fdae61'
      if (value < 90) return '#f46d43'
      return '#d73027'
    },
    async parseImageData() {
      try {
        const url = dataPng
        const result = await parseGrayscalePNG(url)
        // console.log('=== 图片解析结果 ===')
        // console.log('vmin:', result.min, 'vmax:', result.max)
        // console.log('absMax:', result.absMax, 'logAbsMax:', result.logAbsMax)
        // console.log('尺寸:', result.width, 'x', result.height)
        console.log('经纬度范围: lon[', result.lonMin, ',', result.lonMax, '] lat[', result.latMin, ',', result.latMax, ']')
        console.log('全部数据:', result)
        // 示例: 查询某坐标的辐射值
        // console.log('(100.57, 29.55)辐射值:', result.getValue(100.57, 29.55))
        // console.log('图片解析完成:', result.width, 'x', result.height, 'min:', result.min, 'max:', result.max)
      } catch (error) {
        console.error('图片解析失败:', error)
      }
    },
    clearGridData() {
      if (this.gridDataLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.gridDataLayer)
        this.gridDataLayer = null
      }
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    },
    goToStatistics() {
      this.$router.push({ name: 'Statistics' })
    },
    goToPrediction() {
      this.$router.push({ name: 'Predictive' })
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('username')
        localStorage.removeItem('userId')
        localStorage.removeItem('stationId')
        localStorage.removeItem('hyStation')
        localStorage.removeItem('rememberedUser')
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.homeViewBody {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #081325 0%, #0d1f38 50%, #081325 100%);
  position: relative;
  overflow: hidden;
}

.homeViewHeader {
  height: 8vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 8px;
  text-shadow: 0 0 20px rgba(0, 216, 255, 0.5);
  background: linear-gradient(135deg, rgba(0, 216, 255, 0.1) 0%, rgba(0, 100, 150, 0.1) 100%);
  border-bottom: 2px solid rgba(0, 216, 255, 0.3);
  position: relative;
}

.timeBox {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #00d8ff;
  letter-spacing: 2px;
}

.locBox {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.myheaderBtnBox {
  height: 30px;
  width: 500px;
  position: absolute;
  right: 0;
  top: 5vh;
  z-index: 999;
  display: flex;
  justify-content: space-between;
}

.myheaderBtnitem {
  height: 30px;
  width: 150px;
  color: #07D8FE;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  line-height: 30px;
  margin-left: 15px;
}

.myheaderBtnitem:hover {
  color: #fff;
  text-shadow: 0 0 10px rgba(7, 216, 254, 0.8);
}

.user-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-menu i {
  margin-right: 5px;
  font-size: 16px;
}

.homeMainBox {
  height: 92vh;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
}

.mainLayout {
  height: 100%;
  width: 100%;
  display: flex;
  gap: 15px;
}

.leftColumn,
.rightColumn {
  width: 25%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.centerColumn {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.card {
  flex: 1;
  min-height: 0;
}

.chart-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
  position: relative;
}

.chart-title {
  color: #00d8ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 4px solid #00d8ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 4px;
}

.chart-controls {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mini-select {
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.3);
  color: #00d8ff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

.mini-select option {
  background: #0f1f39;
  color: #00d8ff;
}

.mini-date {
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.3);
  color: #00d8ff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  width: 120px;
}

.mini-date::-webkit-calendar-picker-indicator {
  filter: invert(0.7);
  cursor: pointer;
}

.chart-content {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.placeholder-content {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 216, 255, 0.5);
  font-size: 18px;
  letter-spacing: 4px;
}

.map-chart {
  flex: 1;
  width: calc(100% - 20px);
  height: calc(100% - 40px);
  min-height: 200px;
  margin: 10px;
  border-radius: 4px;
  overflow: hidden;
}

.map-chart >>> .leaflet-control-attribution {
  display: none;
}

.map-toolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: rgba(15, 31, 57, 0.9);
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(0, 216, 255, 0.3);
}

.toolbar-label {
  color: #00d8ff;
  font-size: 14px;
  font-weight: 500;
}

.toolbar-btn {
  padding: 4px 12px;
  border: 1px solid rgba(0, 216, 255, 0.3);
  border-radius: 4px;
  background: transparent;
  color: #00d8ff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.toolbar-btn:hover {
  background: rgba(0, 216, 255, 0.2);
  border-color: #00d8ff;
}

.toolbar-btn.active {
  background: rgba(0, 216, 255, 0.3);
  border-color: #00d8ff;
  color: #fff;
}

.opacity-control {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 15px;
  padding-left: 15px;
  border-left: 1px solid rgba(0, 216, 255, 0.3);
}

.opacity-label {
  color: #00d8ff;
  font-size: 14px;
  font-weight: 500;
}

.opacity-slider {
  width: 80px;
  height: 6px;
  cursor: pointer;
  appearance: none;
  background: rgba(0, 216, 255, 0.3);
  border-radius: 3px;
  outline: none;
}

.opacity-slider::-webkit-slider-thumb {
  appearance: none;
  width: 14px;
  height: 14px;
  background: #00d8ff;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid #fff;
}

.opacity-value {
  color: #00d8ff;
  font-size: 12px;
  min-width: 35px;
  text-align: right;
}

.legend {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1000;
  background: rgba(15, 31, 57, 0.9);
  border-radius: 6px;
  padding: 10px;
  border: 1px solid rgba(0, 216, 255, 0.3);
}

.legend-title {
  color: #00d8ff;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.legend-text {
  color: #fff;
  font-size: 12px;
}

/* 数据概览 */
.overview-card {
  flex: 0 0 auto !important;
}

.overview-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 10px 0;
}

.overview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  background: rgba(0, 216, 255, 0.05);
  border: 1px solid rgba(0, 216, 255, 0.15);
  border-radius: 6px;
}

.overview-value {
  font-size: 22px;
  font-weight: 700;
  color: #00d8ff;
  line-height: 1.2;
}

.overview-value .unit {
  font-size: 12px;
  font-weight: 400;
  opacity: 0.7;
}

.overview-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 4px;
}

/* 数据表格 */
.table-wrap {
  overflow: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead th {
  padding: 8px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #00d8ff;
  text-align: left;
  border-bottom: 1px solid rgba(0, 216, 255, 0.3);
  position: sticky;
  top: 0;
  background: rgba(15, 31, 57, 0.95);
}

.data-table tbody td {
  padding: 7px 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  border-bottom: 1px solid rgba(0, 216, 255, 0.08);
}

.data-table tbody tr:hover {
  background: rgba(0, 216, 255, 0.08);
}

.data-table tbody tr:nth-child(even) {
  background: rgba(0, 216, 255, 0.03);
}

.data-table tbody td:first-child {
  color: #00d8ff;
}
</style>